module.exports = __webpack_public_path__ + "img/inspiration.936aa5f9.png";